import { registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AccessTokenInterceptor } from '@core/interceptors';
import { AlertService, AuthService, GlobalSpinnerService, UserService } from '@services';
import { BuildRibbonModule } from '@shared/components';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

registerLocaleData(localePt);

@NgModule({
  declarations: [AppComponent],
  imports: [AppRoutingModule, BrowserAnimationsModule, BrowserModule, BuildRibbonModule, HttpClientModule],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: HTTP_INTERCEPTORS, useClass: AccessTokenInterceptor, multi: true, deps: [AuthService] },
    AlertService,
    AuthService,
    GlobalSpinnerService,
    UserService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
